module.exports = __webpack_public_path__ + "4-o2.jpg?1857f10e46ed9ba0f112839007babe13";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/4-o2.jpg
// module id = 655
// module chunks = 0